import { render, staticRenderFns } from "./OrderFormReviseCharacter.module.vue?vue&type=template&id=253cb42a&scoped=true&"
import script from "./OrderFormReviseCharacter.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormReviseCharacter.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormReviseCharacter.module.vue?vue&type=style&index=0&id=253cb42a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253cb42a",
  null
  
)

export default component.exports